import { render, staticRenderFns } from "./BookInitCard.vue?vue&type=template&id=35b430e2&"
import script from "./BookInitCard.vue?vue&type=script&lang=js&"
export * from "./BookInitCard.vue?vue&type=script&lang=js&"
import style0 from "./BookInitCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports